module.exports = __webpack_public_path__ + "static/media/success.56540b5a.svg";